export type Preference = {
  id: number
  preferenceTypeId: number
  assignmentType: AssignmentType
  programId: number
  programCode: string
  isCompleted: boolean
  name: string
  valueType: ValueType
  value: string
  accessCode: string
}

export type SitePreference = Preference & {
  siteId: number
}

export type SiteUserPreference = Preference & {
  siteUserId: number
}

export type PreferenceType = {
  name: string
  assignmentType: AssignmentType
  valueType: ValueType
  programId: number
  defaultValue: string
  affectsContext: boolean
}

export enum ValueType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  Date = 'Date',
  Stringarray = 'Stringarray',
}

export enum AssignmentType {
  None = 'None',
  Site = 'Site',
  SiteUser = 'SiteUser',
}
